import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *开始观看PPT
 * @param classChapterId
 * 
*/

export const startPPT = classChapterId => Http.post(`${baseUrl}/video/ppt/history/${classChapterId}/ppt`)

/**
 *观看进行中
 * @param historyId
 * 
*/

export const during = historyId => Http.put(`${baseUrl}/video/ppt/history/${historyId}`)

/**
 *ppt到最后一页
 * @param historyId
 * 
*/

export const atLast = historyId => Http.put(`${baseUrl}/video/ppt/history/${historyId}/complete`)

/**
 *开始播放视频
 * @param classChapterId
 * 
*/

export const startVideo = classChapterId => Http.post(`${baseUrl}/video/ppt/history/${classChapterId}/video`)
